import { useMock, fetchPostmanFHIR } from '../../postman'
import { fhirAPI } from '../fhirAPI'

export const readCoverage = async (memberId) => {
	console.log('readCoverage')
	try {
		let results
		const params = {
			url: `Coverage/${memberId}`,
			method: 'GET',
			eCode: 'BP-FA-005'
		}

		if (useMock('COVERAGE')) {
			results = await fetchPostmanFHIR(params)
		} else {
			results = await fhirAPI(params)
		}
		return results
	} catch (error) {
		throw error
	}
}

export const searchCoverage = async (memberId, paramsIn) => {
	try {
		let results
		const params = {
			url: `Coverage?identifier=${memberId}${paramsIn}`,
			method: 'GET',
			eCode: 'BP-FA-006'
		}

		if (useMock('COVERAGE')) {
			results = await fetchPostmanFHIR(params)
		} else {
			results = await fhirAPI(params)
		}
		return results
	} catch (error) {
		throw error
	}
}

export const findCoverage = async (contractId, paramsIn, count = 50) => {
	console.log('findCoverage')
	try {
		let results
		const params = {
			url: `Coverage?identifier=${contractId}&versionId=2&${paramsIn}&_count=${count}`,
			method: 'GET',
			eCode: 'BP-FA-007'
		}

		if (useMock('COVERAGE')) {
			results = await fetchPostmanFHIR(params)
		} else {
			results = await fhirAPI(params)
		}
		return results
	} catch (error) {
		throw error
	}
}
